import _Object$assign from "babel-runtime/core-js/object/assign";

export default {
  loadBusiData: function loadBusiData(newData, bizData) {
    var custTaxInfo = bizData.BIZ_DATA.CUST_TAX_INFO;
    var newCustTaxInfo = _Object$assign({}, _.pick(custTaxInfo, ["PASSIVE_NFE", "TAX_RESIDENT_TYPE", "NAME_ENG", "FULL_ADDRESS_ENG", "ADDRESS", "CITIZENSHIP", "CITIZENSHIP2", "CITIZENSHIP3", "TAXPAYER_IDNO1", "TAXPAYER_IDNO2", "TAXPAYER_IDNO3", "SEL_NO_TAXPAYERID_REASON", "IS_FINANCIAL_INSTITUTION", "UNGET_TAXPAYERID_REASON1", "SEL_NO_TAXPAYERID_REASON1"]));

    var newRegionAndNum = "";
    if (custTaxInfo.TAX_RESIDENT_TYPE == "1") {
      var arr = [];
      var ORG_TAXPAYER_IDNO_0 = !custTaxInfo.CITIZENSHIP ? "" : custTaxInfo.CITIZENSHIP + "-" + (!custTaxInfo.TAXPAYER_IDNO1 ? "无" : custTaxInfo.TAXPAYER_IDNO1);
      var ORG_TAXPAYER_IDNO_1 = !custTaxInfo.CITIZENSHIP2 ? "" : custTaxInfo.CITIZENSHIP2 + "-" + (!custTaxInfo.TAXPAYER_IDNO2 ? "无" : custTaxInfo.TAXPAYER_IDNO2);
      var ORG_TAXPAYER_IDNO_2 = !custTaxInfo.CITIZENSHIP3 ? "" : custTaxInfo.CITIZENSHIP3 + "-" + (!custTaxInfo.TAXPAYER_IDNO3 ? "无" : custTaxInfo.TAXPAYER_IDNO3);
      if (!!ORG_TAXPAYER_IDNO_0) {
        arr.push(ORG_TAXPAYER_IDNO_0);
      }
      if (!!ORG_TAXPAYER_IDNO_1) {
        arr.push(ORG_TAXPAYER_IDNO_1);
      }
      if (!!ORG_TAXPAYER_IDNO_2) {
        arr.push(ORG_TAXPAYER_IDNO_2);
      }
      newRegionAndNum = arr.join(";");
      newCustTaxInfo.CITIZENSHIP = "";
      newCustTaxInfo.IS_TAXPAYER_IDNO_1 = "1";
      newCustTaxInfo.TAXPAYER_IDNO1 = "";
      newCustTaxInfo.TAXPAYER_IDNO2 = "";
      newCustTaxInfo.TAXPAYER_IDNO3 = "";
      newCustTaxInfo.SEL_NO_TAXPAYERID_REASON = "";
    } else {
      newCustTaxInfo.SEL_NO_TAXPAYERID_REASON = newCustTaxInfo.SEL_NO_TAXPAYERID_REASON1;
      newCustTaxInfo.TAXPAYER_IDNO1 = newCustTaxInfo.TAXPAYER_IDNO1 || "";
      newCustTaxInfo.TAXPAYER_IDNO2 = newCustTaxInfo.TAXPAYER_IDNO2 || "";
      newCustTaxInfo.TAXPAYER_IDNO3 = newCustTaxInfo.TAXPAYER_IDNO3 || "";
    }

    newCustTaxInfo.newRegionAndNum = newRegionAndNum;
    newData.custTaxInfo = newCustTaxInfo;

    _.each(bizData.BIZ_DATA.CONTROLLER_TAX_INFO_LIST || [], function (custTaxInfoObj) {
      if (custTaxInfoObj.TAX_RESIDENT_TYPE == "1") {
        var _arr = [];
        var _ORG_TAXPAYER_IDNO_ = !custTaxInfoObj.CITIZENSHIP ? "" : custTaxInfoObj.CITIZENSHIP + "-" + (!custTaxInfoObj.TAXPAYER_IDNO1 ? "无" : custTaxInfoObj.TAXPAYER_IDNO1);
        var _ORG_TAXPAYER_IDNO_2 = !custTaxInfoObj.CITIZENSHIP2 ? "" : custTaxInfoObj.CITIZENSHIP2 + "-" + (!custTaxInfoObj.TAXPAYER_IDNO2 ? "无" : custTaxInfoObj.TAXPAYER_IDNO2);
        var _ORG_TAXPAYER_IDNO_3 = !custTaxInfoObj.CITIZENSHIP3 ? "" : custTaxInfoObj.CITIZENSHIP3 + "-" + (!custTaxInfoObj.TAXPAYER_IDNO3 ? "无" : custTaxInfoObj.TAXPAYER_IDNO3);
        if (!!_ORG_TAXPAYER_IDNO_) {
          _arr.push(_ORG_TAXPAYER_IDNO_);
        }
        if (!!_ORG_TAXPAYER_IDNO_2) {
          _arr.push(_ORG_TAXPAYER_IDNO_2);
        }
        if (!!_ORG_TAXPAYER_IDNO_3) {
          _arr.push(_ORG_TAXPAYER_IDNO_3);
        }
        newRegionAndNum = _arr.join(";");
        custTaxInfoObj.CITIZENSHIP = "";
        custTaxInfoObj.newRegionAndNum = newRegionAndNum;
        custTaxInfoObj.TAXPAYER_IDNO1 = "";
        custTaxInfoObj.TAXPAYER_IDNO2 = "";
        custTaxInfoObj.TAXPAYER_IDNO3 = "";
        custTaxInfoObj.IS_TAXPAYER_IDNO_1 = "1";
        custTaxInfoObj.SEL_NO_TAXPAYERID_REASON = "";
      } else {
        custTaxInfoObj.TAXPAYER_IDNO1 = custTaxInfoObj.TAXPAYER_IDNO1 || "";
        custTaxInfoObj.TAXPAYER_IDNO2 = custTaxInfoObj.TAXPAYER_IDNO2 || "";
        custTaxInfoObj.TAXPAYER_IDNO3 = custTaxInfoObj.TAXPAYER_IDNO3 || "";
        custTaxInfoObj.SEL_NO_TAXPAYERID_REASON = custTaxInfoObj.SEL_NO_TAXPAYERID_REASON1 || "";
      }
    });

    newData.PASSIVE_NFE_LIST = bizData.BIZ_DATA.CONTROLLER_TAX_INFO_LIST;

    return newData;
  }

};


//////////////////
// WEBPACK FOOTER
// ./src/assets/busi-paper/prints/GUOTOU/X2r.js
// module id = 1136
// module chunks = 2